export const EVENT_SAMPLES = {
  sampleEvent: {
    title: 'Sample Event',
    youtubeDetails: [
      {
        youtubeId: 'BTyPHTpoO5s',
        name: 'Live event 1',
        date: 'Sept 06th 2026',
        location: 'Bentonville, AR',
        description:
          'Join us live for behind-the-scenes coverage of our sample event.'
      }
    ],
    photos: [
      'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
      'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800'
    ],
    iframes: [
      {
        id: '1ABC_FOLDER_ID_1234567890',
        view: 'grid',
        name: 'Gallery',
        aspectRatio: 16 / 9,
        height: '60vh',
        description: 'Browse all photos from the event in Google Drive',
        allow: 'fullscreen'
      }
    ]
  },
  empty: {
    title: '',
    youtubeDetails: [],
    photos: [],
    iframes: []
  }
};
